import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'arrayFilter',
    pure: false,
    standalone: true,
})
export class ArraFilterPipe implements PipeTransform {
  transform(items: any[], property: string, value: any): any[] {
    return items.filter((item) => item[property] == value) ?? [];
  }
}
